@if (visible) {
  <div class="modal_customer"
    >
    <div class="modal_customer_body">
      <div class="text-center">
      </div>
      <div class="modal_text_md text-center">{{ title }}</div>
      <br>
        @if ( message.length > 0 ) {
          <div class="modal_text_sm text-center">
            {{ message }}
          </div>
        }
        <br>
          <button class="button button-active" (click)="confirm()">{{ confirmText }}</button>
          <button class="button button-default" (click)="dismiss()">{{ cancelText }}</button>
        </div>
      </div>
    }
